
import { NotificationIcon, PoliciesIcon, SchoolIcon, UserInfoIcon } from "Assets/icons/v2";
import { CHANGE_PASSWORD } from "config/paths";
import React from "react";
import { ChevronRight, Lock } from "react-feather";
import { useNavigate } from "react-router-dom";

const options = [
    // {
    //     id: 1,
    //     label: "Notifications Settings",
    //     icon: <NotificationIcon size={18} />,

    // },
    {
        id: 2,
        label: "User Information",
        icon: <UserInfoIcon size={18} />,
        url: "/profile/user-information",
    },
    {
        id: 3,
        label: "Change Password",
        icon: <Lock size={18} />,
        url: CHANGE_PASSWORD,
    },
    // {
    //     id: 3,
    //     label: "My Schools",
    //     icon: <SchoolIcon size={18} />,
    //     url: "/profile/my-school",

    // },
    // {
    //     id: 4,
    //     label: "Policies",
    //     icon: <PoliciesIcon size={18} />,
    // },
];

function index() {
    const navigate = useNavigate()
    return (
        <div className="col-lg-10 p-3">
            <h5 className="mb-3 section-title-main">My Profile</h5>

            <div className="profile-option-container">
                {options.map((item, index) => (
                    <div
                        onClick={() => navigate(item?.url)}
                        key={item.id}
                        className="profile-option-main"
                        style={{
                            border: "1px solid #93278F",
                            color: "#93278F",
                            // backgroundColor: (index === 0 || index === 3) && '#e9e9e9'
                        }}
                    >
                        <div className="d-flex align-items-center gap-3">
                            <span >{item.icon}</span>
                            <span className="profile-option-label">
                                {item.label}
                            </span>
                        </div>

                        <ChevronRight size={16} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default index;
